<template lang="pug">

    div

        .ui.info.message(v-if='jobModels.length === 0')
            | Keine Anfragen vorhanden

        .ui.relaxed.divided.list(v-else)

            item(
                v-for='jobModel in jobModels'
                v-bind:key='jobModel.id'
                v-bind:job-model='jobModel'
                v-bind:offer-models='filterOfferModelsByJobId(jobModel.id)'
                v-bind:supplier-model='findSupplierModelById(jobModel.supplier)'
                v-bind:variant-models='variantModels'
            )

        update-form-modal(
            ref="updateFormModal"
            v-bind:address-models='addressModels'
            v-bind:job-models='jobModels'
            v-bind:offer-models='offerModels'
            v-bind:product-model='productModel'
            v-bind:supplier-models='supplierModels'
            v-bind:variant-models='variantModels'
        )

        button.ui.primary.fluid.icon.button(
            v-on:click="showUpdateFormModal()"
            v-if="productModel.status === 'IN_PROCESS'"
        ) Lieferantenauswahl


</template>

<script>
    import * as R from 'ramda'
    import ActionRow from '@/components/form/ActionRow'
    import Item from './job-list/Item'
    import UpdateFormModal from './job-list/UpdateFormModal'

    // noinspection JSUnusedGlobalSymbols
    export default {
        components: { ActionRow, Item, UpdateFormModal },

        methods: {

            filterOfferModelsByJobId(jobId) {
                return R.filter(R.propEq('job', jobId), this.offerModels)
            },

            findSupplierModelById(supplierId) {
                return R.find(R.propEq('id', supplierId), this.supplierModels)
            },

            showUpdateFormModal() {
                this.$refs.updateFormModal.show()
            }

        },

        props: {

            addressModels: {
                type: Array,
                required: true
            },

            jobModels: {
                type: Array,
                required: true
            },

            offerModels: {
                type: Array,
                required: true
            },

            productModel: {
                type: Object,
                required: true
            },

            supplierModels: {
                type: Array,
                required: true
            },

            variantModels: {
                type: Array,
                required: true
            },

        }

    }
</script>
